import { logger } from '@tock/logging';

export const ENCODED_OBJECT_KEY = 'encoded_obj';

export const parseEncodedObjectParam = (search?: Dictionary<string> | null): Dictionary<string> => {
  const encodedObj = search ? search[ENCODED_OBJECT_KEY] : undefined;
  return parseEncodedObject(encodedObj);
};

export const parseEncodedObject = (encodedObj?: string | null): Dictionary<string> => {
  try {
    if (encodedObj) {
      const decodedObj = atob(encodedObj);
      return JSON.parse(decodedObj);
    }
  } catch (e) {
    logger.error('Error parsing encoded object', e);
  }
  return {};
};
